// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DesktopMenu_wrapper__T0FLg","item":"DesktopMenu_item__TMDtn","itemBlack":"DesktopMenu_itemBlack__2vxtA"};